const getValidationType = () => { 
    return ValidationType;
}
const getSuspendType = () => {
    return SuspendType;
}

let SuspendType = {
    PatientSuspending: 1,
    ContractorSuspending: 2,
    ContractorClientSuspending: 3,
    ContractSuspending: 4
}

const getActionNameEnum = () => {
    return ActionNameEnum;
}
let ActionNameEnum = {
    changeContractor: 1,
    delete: 2,
    copyContractor: 3,
    copyItemPrice: 4,
    clearAllData: 5,
    deleteAllRows: 6,
    deleteRow: 7,
    ProductClassificationChange: 8,
    productCategoryChange: 9,
    assignStatusChange: 10
}

const BGAssignmentEnums = () => {
    return BGAssignment
}
const getContractorsEnum = () => {
    return ContractorsEnum;
}
let ContractorsEnum = {
    deleteAddress: 11,
    deleteNestedContactsPerson: 32,
    deleteParentContactsPerson: 31, 
}
const SavecontractorProductResultEnums = () => {
    return SavecontractorProductResult;
}
const SaveResultEnums = () => {
    return SaveResult;
}

const SaveBillingResultEnums = () => {
    return SaveResultBilling;
}

const UploadExcelEnums = () => {
    return UploadExcel;
}

const UploadExcelContractorEnums = () => {

    return UploadExcelContractor
}
const PopupTypeEnums = () => {
    return PopupType;
}
const ConfigCompanyLimitCalculationEnums = () => {
    return ConfigCompanyLimitCalculation;
}
const ConfigServiceExceedLimitEnums = () => {
    return ConfigServiceExceedLimit;
}
const ConfigMarkServiceExceedLimitEnums = () => {
    return ConfigMarkServiceExceedLimit;
}
const getNationalityEnums = () => {
    return Nationality;
}
let ValidationType = {
    Duplicated: 1
}
//  M
let SavecontractorProductResult = {   
    ContractorNotExist:1,
    ProductNotExist:2,
    DuplicateEnName:3,
    DuplicateArName : 4,
    DuplicateCode : 5,
    ProductIDDuplicate: 6,
    CannotAddProductWithMedicationClassification: 7
}
let BGAssignment = {
    SavedSuccessfully: 1,
    ErrorInSaving: 2,
    HaveReference: 5,
    SelectFile: 9,
    SelectValidExcelFile: 11,
    InvalidBillingGroupName: 12,
    InvalidProductName: 13,
    InvalidProductNameBillingGroupName: 14,
    InactiveBillingGroupName: 17,
    Concurrency: 3
}
let SaveResult= {
    Success : 1,
    Failure : 2,
    Concurrency: 3,
    DuplicationError: 4
}
let UploadExcel={
    Success : 1,
    DataValidationErrors : 2,
    FileIsNull : 3,
    FileIsNotExcel : 4,
    FileIsEmpty : 5,
    InternalServerError : 6,
    InvalidContractor: 7,
    Failure: 8,
    Concurrency: 9,
	WarninngMissingData: 10
    

}

let UploadExcelContractor={
   Success : 1,
   Failure : 2,
   WrongFile : 3,
   EmptyExcel : 4,
   NotSameFile : 5,
   NeedToReview : 6,
   ContractorMismatch : 7,

}
let SaveResultBilling = {
    Success: 1,
    Failure: 2,
    Concurrency: 3,
    SelectParentError: 4,
    HaveReference: 5,
    ArabicEnglishNamesExists: 6,
    ArabicNameExists: 7,
    EnglishNameExists: 8,
    SelectFile: 9,
    ActiveParentError: 10,
    SelectValidExcelFile: 11,
    InvalidBillingGroupName: 12,
    InvalidProductName: 13,
    InvalidProductNameBillingGroupName: 14,
    DuplicatedContractorContactValue: 15,
    DuplicatedContractorContactDefault: 16,
    InactiveBillingGroupName: 17,
    EffectiveDateExists: 18,
    PricePlanNotValid: 19,
    PackageMustHaveDetail: 20,
    SpecialityConcurrency: 21,
    BillingGroupConcurrency: 22,
    ProductConcurrency: 23,
    ProductNotAssginToBillingGroup: 24,
    ProductNotActive: 25,
    NameDuplication: 26,
    NotItemProduct: 27,
    DeletedProduct: 28,
    NotOriginalUOM: 29,
    NotOriginalProductCategory: 30,
    ConcurrencyEffectiveDate: 31,
    PatientTransaction: 32,
    AssignedToContract: 33,
    DuplicatedSuspend: 34,
    NoSuspendStatus: 35,
    DuplicatedSuspendStatusDates: 36,
    InvalidStartEndDate: 37,
    InActiveContractor: 38,
    InvalidContractorClient: 39,
    InvalidBeneficiaryType: 40,
    InvalidMaxAmount: 41,
    InvalidContractCategory: 42,
    InvalidItemPriceList: 43,
    InvalidServicePriceList: 44,
    InvalidEndDate: 45,
    PricePalnHasTransaction: 46,
    DeletedContractor: 47,
    SuspendContractor: 48,
    DeletedContractorClient: 49,
    SuspendContractorClient: 50,
    DeletedContractCategory: 51,
    InActiveContractCategory: 52,
    DeletedBeneficiaryType: 53,
    InActiveBeneficiaryType: 54,
    DeletedBillingGroup: 55,
    InActiveBillingGroup: 56,
    InvalidContractDetail: 57,
    InvalidBillingGroup: 58,
    InvalidProduct: 59,
    InvalidExcludedProduct: 60,
    InActiveProduct: 61,
    ContractHasPatientTransaction: 62,
    ServiceHasContract: 63,
    PriceListConcurrency: 64,
    DuplicatedBillingGroup: 65,
    DuplicatedProduct: 66,
    InvalidDetail: 67,
    InsuranceCardHasPatientTransaction: 68,
    InvalidLengthName: 69,
    TaxHasPatientTransaction: 70,
    HasBarcodeConfig: 71,
    InActiveSpeciality: 72,
    SelectAtLeastOne: 73,
    InvalidPackageDetail: 74,
    InvalidDetailRow: 75,
    InvalidCategory: 76,
    OdooEnglishNameDuplicated: 77,
    OdooInvalidProductCategory: 78,
    OdooSomethingWentWrong: 79,
    OdooUsedProduct: 80,
    ContractorMedicationIntegrationTypeDuplicated: 83
};
 
let PopupType={
    Success : 1,
    Error : 2,
    Warning : 3,  
}
var ConfigCompanyLimitCalculation = {
    CompanyShare: 1,
    NetPrice: 2,
    GrossPrice: 3
}
var ConfigServiceExceedLimit = {
    AllServices: 1,
    AllServicesExceptRejected: 2,
}
var ConfigMarkServiceExceedLimit = {
    AllServices: 1,
    ExceededServicesOnly: 2,
}
var Nationality = {
    Egypt: 18,
    KSA: 56,
}
//  Make all the Enums in one export
export {
    getValidationType, ConfigCompanyLimitCalculationEnums, ConfigServiceExceedLimitEnums, ConfigMarkServiceExceedLimitEnums, getActionNameEnum, SavecontractorProductResultEnums, SaveResultEnums, SaveBillingResultEnums, BGAssignmentEnums, UploadExcelEnums,UploadExcelContractorEnums, PopupTypeEnums,
    getSuspendType, getContractorsEnum, getNationalityEnums
};
